import React from 'react';
import { twMerge } from 'tailwind-merge';

export default function Button({ 
  children, 
  variant = 'primary', 
  className = '', 
  ...props 
}) {
  const baseClasses = 'rounded-pill font-semibold transition-all duration-200';
  
  const variantClasses = {
    primary: 'bg-violet text-white hover:bg-violet/90 px-6 py-3',
    secondary: 'bg-celadon text-gunmetal hover:bg-celadon/90 px-6 py-3',
    outline: 'border-2 border-violet text-violet hover:bg-violet/10 px-6 py-3',
    link: 'text-violet hover:underline p-0 bg-transparent',
    destructive: 'bg-bittersweet text-white hover:bg-bittersweet/80 focus:ring-2 focus:ring-bittersweet/50 px-6 py-3',
    ghost: 'text-midnight hover:bg-light-purple/10 px-4 py-2'
  };

  const sizeClasses = {
    sm: 'text-sm px-4 py-2',
    md: 'px-6 py-3',
    lg: 'text-lg px-8 py-4'
  };

  // Determine the size (default to md if not specified)
  const size = props.size || 'md';
  
  // Remove size from props to avoid passing it as an HTML attribute
  const { size: _, ...otherProps } = props;

  return (
    <button 
      className={twMerge(
        baseClasses, 
        variantClasses[variant], 
        sizeClasses[size],
        props.disabled && 'opacity-60 cursor-not-allowed',
        className
      )}
      {...otherProps}
    >
      {children}
    </button>
  );
}